import React from 'react';
import {View} from 'react-native';
import {parse} from 'date-fns';

import Text from '/component/base/Text';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './CurrentDate.style';

export const CurrentDateEdge30 = ({date}: {date: string}) => {
  const dateUtil = getDateUtilDefaultInstance();
  const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
  const formattedDate = dateUtil.formatDate(
    new Date(parsedDate),
    'EEEE, MMMM dd',
  );
  const today = dateUtil.formatDate(new Date(), 'yyyy-MM-dd');
  const isToday = date === today;
  return (
    <View style={styles.container}>
      <View style={styles.dateRow}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.dattextAligne}
          isBold
          accessible={true}>{` ${formattedDate}`}</Text>
        {isToday && (
          <View style={styles.todayBadge}>
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              style={styles.todayText}
              accessible={true}>
              Today
            </Text>
          </View>
        )}
      </View>
      <View style={styles.line} />
    </View>
  );
};
